import {
    MeshBasicMaterial,
    CircleGeometry,
    RingGeometry,
    SphereGeometry,
    Mesh,
    Group,
} from 'three';
import Experience from '../Experience.js';

export default class Waypoint {
    constructor(position) {
        this.experience = new Experience();
        this.scene = this.experience.scene;
        this.debug = this.experience.debug;
        this.position = position;

        if (this.debug.active) this.setupMesh();
    }

    setupMesh() {
        const helperMaterial = new MeshBasicMaterial();
        helperMaterial.transparent = true;
        helperMaterial.opacity = 0.2;
        const helperGeometry = new CircleGeometry(1, 64);
        this.circle = new Mesh(helperGeometry, helperMaterial);
        this.circle.position.set(0, 0, -2);

        const ringMaterial = new MeshBasicMaterial();
        ringMaterial.transparent = true;
        ringMaterial.opacity = 0.8;
        const ringGeometry = new RingGeometry(1, 1.1, 64);
        this.ring = new Mesh(ringGeometry, ringMaterial);
        this.ring.position.set(0, 0, -2);

        const sphereMaterial = new MeshBasicMaterial();
        sphereMaterial.transparent = true;
        sphereMaterial.opacity = 0.8;
        const sphereGeometry = new SphereGeometry(0.5, 64, 64);
        this.sphere = new Mesh(sphereGeometry, sphereMaterial);
        this.sphere.position.set(0, 0, 0);

        this.waypoint = new Group();
        this.waypoint.add(this.circle, this.ring, this.sphere);
        this.waypoint.position.set(this.position.x, this.position.y, this.position.z);
        this.waypoint.rotateX(-Math.PI / 2);

        this.scene.add(this.waypoint);
    }
}
